import { Component, inject } from '@angular/core';
import { GdprService } from '../../service/gdpr.service';
import { MatDialog } from '@angular/material/dialog';
import { AddProcessingActivitiesComponent } from './add-processing-activities/add-processing-activities.component';

@Component({
    selector: 'app-gdpr',
    standalone: false,
    templateUrl: './gdpr.component.html',
    styleUrl: './gdpr.component.scss'
})
export class GdprComponent {
    proactService = inject(GdprService);
    dialog = inject(MatDialog);

    addActivity() {
        let dia = this.dialog.open(AddProcessingActivitiesComponent, {
            panelClass: "wide-dialog",
            autoFocus: false,
        });
    }
    exportActivities() { }
}
